
import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { DateType, Addresses } from '@/models/job'
import Mixin from '@/mixins'

@Component({
  name: 'JobSubInformation',
})
export default class JobSubInformation extends mixins(Mixin) {
  @Prop({ type: Object || null }) readonly modified: DateType | null
  @Prop({ type: Object }) readonly addresses: Addresses
  @Prop({ type: Number }) readonly minExperienceId: number
  @Prop({ type: Array }) readonly jobLevelsIds: number[]
  @Prop({ type: Array }) readonly skillsIds: number[]
  @Prop({ type: Array }) readonly jobTypesIds: number[]
  @Prop({ type: Array }) readonly supports: any[]
  @Prop({ type: Array }) readonly recruimentProcess: any[]
  @Prop({ type: Array }) readonly contractTypesIds: number[]
  @Prop({ type: Array, default: () => [] })
  @Prop({ type: Array, default: () => [] })
  readonly jobTypesArr: string[]

  showRecruitmentProcessMobile = false

  get recruimentProcessFiltered() {
    return this.recruimentProcess.filter((item) => item.name !== '')
  }
}
